import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["dialog"];

  open(event) {
    event.preventDefault();

    if (!this.hasDialogTarget) return;
    this.dialogTarget.showModal();
  }
}
